var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.messagePreview,{tag:"component",attrs:{"message":_vm.message,"is-opponent-message":_vm.isOpponentMessage}})}
var staticRenderFns = []

export { render, staticRenderFns }